import { createRoutine, promisifyRoutine } from 'redux-saga-routines';

export const garbageRoutine = createRoutine('GARBAGE')
export const garbageRoutinePromiseCreator = promisifyRoutine(garbageRoutine);
